<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 금리 안내(정기예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">USD</th>
          <th scope="col">KHR</th>
          <th scope="col">{{ /*금리구분*/ $t("MDEP-01-02-02-08") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1M</td>
          <td>1.20</td>
          <td>1.70</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
        <tr>
          <td>3M</td>
          <td>2.25</td>
          <td>2.75</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
        <tr>
          <td>6M</td>
          <td>3.00</td>
          <td>3.50</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
        <tr>
          <td>12M</td>
          <td>4.00</td>
          <td>4.50</td>
          <td>{{ /*확정금리*/ $t("MDEP-01-02-02-09") }}</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-etc">· {{ /*영업점 내점상담 후, 금리 결정*/ $t("MDEP-01-02-02-10") }}</div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      currentTab: 0,
    };
  },
};
</script>